import React, {Component} from 'react';

import styled from 'styled-components'

const H1 = styled.h1`
  line-height: 1.1;
  font-weight: 800;
`;

const H2 = styled.h2`
  line-height: 1.1;
  font-weight: bold;
`;

const H3 = styled.h3`
  line-height: 1.1;
  font-weight: 800;
`;

class H extends Component {
    render() {
        const Heading = "h" + this.props.size;
        const style = "styledH" + this.props.styleSize;
        switch (Heading) {
            case 'h1':{
                return <H1 {...this.props} className={style + ' ' + this.props.className} >{this.props.children}</H1>
            }
            case 'h2':{
                return <H2 {...this.props} className={style + ' ' + this.props.className} >{this.props.children}</H2>
            }
            case 'h3':{
                return <H3 {...this.props} className={style + ' ' + this.props.className} >{this.props.children}</H3>
            }
            default: {
                return <Heading {...this.props} className={style + '' + this.props.className}>
                    {this.props.children}
                </Heading>
            }

        }
    }
}

export default styled(H)`
  margin: 0;
  font-size: ${p => p.theme['sH' + p.styleSize] ? p.theme['sH' + p.styleSize] + 'px' : 'inherit'}; //automatic h font size from theme
`;